/**
 * Filter Preset Service
 * API calls for filter preset management
 */

import { api } from './api';
import type {
  FilterPreset,
  CreateFilterPresetRequest,
  UpdateFilterPresetRequest,
} from '../types/okr';

class FilterPresetService {
  /**
   * Create a new filter preset
   */
  async createPreset(data: CreateFilterPresetRequest): Promise<FilterPreset> {
    const response = await api.post('/filter-presets', data);
    return response.data.data.preset;
  }

  /**
   * Get all filter presets (user's own + public ones)
   */
  async getPresets(): Promise<FilterPreset[]> {
    const response = await api.get('/filter-presets');
    return response.data.data.presets;
  }

  /**
   * Get a single filter preset by ID
   */
  async getPresetById(id: string): Promise<FilterPreset> {
    const response = await api.get(`/filter-presets/${id}`);
    return response.data.data.preset;
  }

  /**
   * Update a filter preset
   */
  async updatePreset(id: string, data: UpdateFilterPresetRequest): Promise<FilterPreset> {
    const response = await api.patch(`/filter-presets/${id}`, data);
    return response.data.data.preset;
  }

  /**
   * Delete a filter preset
   */
  async deletePreset(id: string): Promise<void> {
    await api.delete(`/filter-presets/${id}`);
  }

  /**
   * Get the default filter preset
   */
  async getDefaultPreset(): Promise<FilterPreset | null> {
    const response = await api.get('/filter-presets/default');
    return response.data.data.preset;
  }
}

export const filterPresetService = new FilterPresetService();
